angular.module('unergie.main')
.directive('salesTunnelBPBillingV3', ($uibModal, $filter, MetaWatcher, ApiUser, ErrorCatcher) =>
    ({
        restrict: 'E',
        scope: {
            draft: '=',
            disableContractEdition: '=',
        },
        templateUrl: '/states/salesTunnelV3/component/salesTunnelBPBillingV3.html',
        link($scope) {
            $scope.form = {}
            $scope.addressSearch = ''
            $scope.saveDraft = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_DRAFT')

            $scope.checkBillAddress = (store) => {
                return store.addr_prm || store.addr_source === 'PRM' ||
                (!!store.bill_addr_num_street &&
                !!store.bill_addr_post_code &&
                !!store.bill_addr_city_lbl)
            }

            // VALIDATORS
            const initComponentValidator = () => {
                MetaWatcher.notif('SALES_TUNNEL.SET_VALIDATORS', {
                    isPaymentTypeValid(store) {
                        return ['SEPA', 'CB'].includes(store.draft.payment_type)
                    },
                    isInvoicePaymentModeValid(store) {
                        // true pour shunter la validation
                        return true || ['SEPA', 'CB', 'CHECK', 'CASH'].includes(store.draft.invoice_payment_mode)
                    },
                    isInvoiceCommunicationChannelValid(store) {
                        return ['EMAIL', 'POST'].includes(store.draft.invoice_communication_channel)
                    },
                    isBillingAddressValid(store) {
                        return $scope.checkBillAddress(store.draft)
                    },
                })
            }

            $scope.lookupAddr = function (addr) {
                $scope.coordinates = undefined
                $scope.searching = true
                const p = ApiUser.lookupStrictAddr({ q: addr }).$promise
                p.then(() => {
                    $scope.searching = false
                }).catch(() => {
                    $scope.searching = false
                })
                return p
            }

            $scope.updateAddress = function (data) {
                const payload = {
                    bill_addr_city_code: data.addr_city_code,
                    bill_addr_city_lbl: data.addr_city_lbl,
                    bill_addr_num_street: data.addr_num_street,
                    bill_addr_post_code: data.addr_post_code,
                }
                _.assign($scope.form, payload)
                $scope.saveDraft(payload)
                $scope.addressSearch = ''
            }

            const initForm = (draft) => {
                _.assign($scope.form, _.pick(draft, [
                    'bill_addr_bat',
                    'bill_addr_city_code',
                    'bill_addr_city_lbl',
                    'bill_addr_details',
                    'bill_addr_locality',
                    'bill_addr_num_street',
                    'bill_addr_post_code',
                    'invoice_communication_channel',
                    'invoice_payment_mode',
                    'payment_type',
                ]))
                $scope.form.addr_prm = draft.addr_source === 'PRM'
            }

            $scope.$watch('draft', initForm)

            const activate = function () {
                initComponentValidator()
                initForm($scope.draft)
            }

            activate()
        },
    })
)
